/**
 * Helper para facilitar integração com PrintQueueContext
 * Usa um singleton simples para acesso global sem hooks
 */
export type PrintJobResult = 'completed' | 'failed' | 'uncertain';
export type PrintJobResultCallback = (result: PrintJobResult) => void | Promise<void>;

let adicionarNaFilaGlobal: ((job: any) => unknown) | null = null;

export const setPrintQueueInstance = (adicionarFn: ((job: any) => unknown) | null) => {
    adicionarNaFilaGlobal = adicionarFn;
};

export const adicionarImpressaoNaFila = (job: any) => {
    if (adicionarNaFilaGlobal) {
        // Permite ao chamador saber se o trabalho foi aceito pela fila.
        return adicionarNaFilaGlobal(job) !== false;
    } else {
        console.warn('⚠️ [FILA] Contexto não inicializado - impressão direta será usada');
        return false;
    }
};

/**
 * Helper para criar job de impressão a partir de dados comuns
 */
export const criarJobImpressao = (params: {
    comandosEscPos: Uint8Array;
    dados: any;
    impressoraConfig: {
        deviceId?: string;
        address?: string;
        ip?: string;
        porta?: number;
        printerName?: string;
    };
    tipo: 'ble' | 'spp' | 'rede' | 'local';
    quantidadeVias: number;
    origem: string;
    onResult?: PrintJobResultCallback;
}) => {
    return {
        tipo: params.tipo,
        dados: params.dados,
        comandosEscPos: params.comandosEscPos,
        impressoraConfig: params.impressoraConfig,
        quantidadeVias: params.quantidadeVias,
        origem: params.origem,
        ...(params.onResult ? { onResult: params.onResult } : {}),
    };
};
